/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetCoworkingsByOperatorModel,
  IGetCoworkingsByOperatorRequest,
  IMappers,
  IGetCoworkingsByOperatorResponse,
  IGetCoworkingsByOperatorResponseError,
  TGetCoworkingsByOperatorResponse,
} from './types';

const defaultConfig: TGetCoworkingsByOperatorModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'coworking',
  pathApi: '/v1/get-coworkings-by-operator/',
  hostType: 'api',
} as TGetCoworkingsByOperatorModel;

function createGetCoworkingsByOperatorModel(
  parameters: IGetCoworkingsByOperatorRequest,
): TGetCoworkingsByOperatorModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetCoworkingsByOperatorOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetCoworkingsByOperatorRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetCoworkingsByOperator<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetCoworkingsByOperatorOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetCoworkingsByOperatorResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetCoworkingsByOperatorModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetCoworkingsByOperatorResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetCoworkingsByOperatorResponseError);
    }
  }

  return { response, statusCode } as TGetCoworkingsByOperatorResponse;
}

export { defaultConfig, createGetCoworkingsByOperatorModel, fetchGetCoworkingsByOperator };
